import { Dialog, DialogContent } from '@mui/material';
import MDEditor from '@uiw/react-md-editor';
import React from 'react';

import AttachmentList from '../../../../shared/components/AttachmentList';
import { Attachment } from '../../../../types/work';
import * as S from './styled';

interface ProjectContextDialogProps {
    isOpen: boolean;
    onClose: () => void;
    projectName: string;
    projectDescription: string;
    projectAttachments?: Attachment[];
}

const ProjectContextDialog: React.FC<ProjectContextDialogProps> = ({
    isOpen,
    onClose,
    projectName,
    projectDescription,
    projectAttachments
}) => {
    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            aria-labelledby="project-context-dialog-title"
            PaperProps={S.dialogPaperProps}
        >
            <S.StyledDialogTitle id="project-context-dialog-title">
                {projectName} Context
                <S.CloseButton
                    aria-label="close"
                    onClick={onClose}
                >
                    <S.CloseIcon>×</S.CloseIcon>
                </S.CloseButton>
            </S.StyledDialogTitle>
            <DialogContent>
                <S.SectionTitle>
                    Description
                </S.SectionTitle>
                <S.MarkdownContainer>
                    <MDEditor.Markdown source={projectDescription || ''} />
                </S.MarkdownContainer>
                {projectAttachments && projectAttachments.length > 0 && (
                    <>
                        <S.SectionTitle>
                            Project Attachments
                        </S.SectionTitle>
                        <S.FilesContainer>
                            <AttachmentList 
                                attachments={projectAttachments}
                                showTitle={false}
                            />
                        </S.FilesContainer>
                    </>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default ProjectContextDialog;
